// extracted by mini-css-extract-plugin
module.exports = {"introSection":"PageIntro_introSection__2zAHy","introImg":"PageIntro_introImg__3aI4o","textSection":"PageIntro_textSection__UR6Ad","introSub":"PageIntro_introSub__12hNB"};